const state = {
  landingIndex: -1,
  autoScroll: true,
  isWheelListenerInitialized: false,
  direction: "rtl",
};

const mutations = {
  increment(state, n) {
    if (state.landingIndex < 5) {
      state.landingIndex += n;
      state.direction = "rtl";
    }
  },
  decrement(state, n) {
    if (state.landingIndex >= 0) {
      state.landingIndex -= n;
      state.direction = "ltr";
    }
  },
  setIndexFromMenu(state, value) {
    state.landingIndex = value;
  },
  setWheelListener(state, value) {
    state.isWheelListenerInitialized = value;
  },
  toggleAutoScroll(state, value) {
    state.autoScroll = value;
  },
  setDirection(state, value) {
    state.direction = value;
  },
};

const getters = {
  landingIndex: (state) => parseInt(state.landingIndex),
  isWheelListenerInitialized: (state) => state.isWheelListenerInitialized,
  direction: (state) => state.direction,
  autoScroll: (state) => state.autoScroll,
};

const actions = {
  increment({ commit }) {
    commit("increment", 1);
  },
  decrement({ commit }) {
    commit("decrement", 1);
  },
  setIndexFromMenu({ commit }, value) {
    commit("setIndexFromMenu", value);
  },
  setWheelListener({ commit }, value) {
    commit("setWheelListener", value);
  },
  setDirection({ commit }, value) {
    commit("setDirection", value);
  },
  toggleAutoScroll({ commit }, value) {
    commit("toggleAutoScroll", value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
